// extracted by mini-css-extract-plugin
module.exports = {"indicator":"styles_indicator__nScUf","inlineIndicator":"styles_inlineIndicator__zMUNf","withLogo":"styles_withLogo__8QrL_"};